import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import documentDeliveryEsCL from './locales/es-CL.json';
import documentDeliveryEnUS from './locales/en-US.json';
import documentDeliveryPtBR from './locales/pt-BR.json';

export const documentDeliveryI18n = buildScopedI18n({
  esCL: documentDeliveryEsCL,
  enUS: documentDeliveryEnUS,
  ptBR: documentDeliveryPtBR,
});